export enum FusionStateEnum {
  LOADING,
  SELECTION,
  CONFIRMATION,
  SUCCESS,
  ERROR
}
